import { UnknownAction } from "@reduxjs/toolkit";
import { FETCH_ORGANIZATION_REQUEST, FETCHING_ORGANIZATION_FAILED, FETCHING_ORGANIZATION_SUCCEEDED, INVALIDATE_ORGANIZATIONS } from "../actions/actionTypes";
import { PaginatedRecords } from "src/types/common";
import { FetchingOrganizationFailed, Organization } from "src/types/organization";


export interface OrganizationState {
  items: Organization[];
  pagination: {
    currentPage: number;
    totalPages: number;
    recordsPerPage: number;
  };
  loading: boolean;
  error: any;
}

const initialState = {
  items: [],
  loading: false,
  pagination : {
    currentPage: 0,
    totalPages: 0,
    recordsPerPage: 0,
  },
  error: null
}
export function oraganizationReducer(
  state: OrganizationState = initialState,
  action: UnknownAction,
){
  switch(action.type){
    case FETCH_ORGANIZATION_REQUEST:{
      return {
        ...state,
        loading: true,
      };
    }

    case FETCHING_ORGANIZATION_SUCCEEDED:{
      const { currentPage, records } = action.payload as PaginatedRecords<Organization>;
      const updatedRecords = currentPage != 0 ? [...state.items, ...records] : records;
      return {
        ...state,
        loading: false,
        pagination: {
          ...state.pagination,
          currentPage,
        },
        items: updatedRecords,
      };
    }
    case FETCHING_ORGANIZATION_FAILED:{
      const { error } = action.payload as FetchingOrganizationFailed;
      return {
        ...state,
        loading: false,
        error,
      };
    }
    case INVALIDATE_ORGANIZATIONS : {
      return {
        ...state,
        items: [],
        loading: false,
      }
    }
    default:
      return state;
  }
};